/**
 * Created by Ivo Mehide <ivo@degeetia.ee> on 19.05.17.
 */

import React from "react";
import PropTypes from "prop-types";

import NotificationList from "./NotificationList";

class NavbarNotifications extends React.Component {
    static propTypes = {
        notifications: PropTypes.array
    };

    static defaultProps = {};

    constructor(props) {
        super(props);
        this.state = {
            dropdownVisible: false
        };
        this.toggleDropdown = this.toggleDropdown.bind(this);
    }

    toggleDropdown(e) {
        e.preventDefault();
        if ((this.props.notifications && this.props.notifications.length > 0) || this.state.dropdownVisible) {
            this.setState({
                dropdownVisible: !this.state.dropdownVisible
            });
        }
    }

    render() {
        let notificationCount = (this.props.notifications ? this.props.notifications.length : 0);
        let openClass = (this.state.dropdownVisible ? "open" : "");
        return (
            <li className={"dropdown " + openClass}>
                <a id="notificationDropdown" className="dropdown-toggle count-info" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" href="#"
                   onClick={this.toggleDropdown}>
                    <i className="fa fa-bell"></i>
                    {notificationCount > 0 ? (<span className="label label-primary">{notificationCount}</span>) : ""}
                </a>
                {this.state.dropdownVisible ? (<NotificationList notifications={this.props.notifications} currentTime={new Date()}/>) : ""}
            </li>
        );
    }
}

export default NavbarNotifications;
